import {BreadCrumb} from 'primereact/breadcrumb';
import {Button} from 'primereact/button';
import {memo, useMemo} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import ProductGrid from '../components/ProductGrid';
import {productCategoriesData} from '../data/categories';
import {useAppSelector, useTranslation} from '../hooks';
import localization from '../locale/localization.json';
import {languageState} from '../redux/slices/app';
import {Localization} from '../types';

const productList = Object.values(productCategoriesData);

const ProductCategory = () => {
  const {t} = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const selectedLanguage = useAppSelector(languageState);

  const categoryName = useMemo(
    () => location.pathname.split('/').pop(),
    [location],
  );

  const product = useMemo(() => {
    return productList.find((p) => t(p.name) === categoryName);
  }, [categoryName, t]);

  const items = useMemo(() => [{label: t(product?.title ?? '')}], [product, t]);
  const home = useMemo(() => {
    return {icon: 'pi pi-home', url: '/'};
  }, []);
  console.log(window.location.pathname.split('/')[1]);
  return (
    <section className="">
      <BreadCrumb model={items} home={home} />

      <h1 className="underline">
        {`${t(product?.title ?? '')}`.toLocaleUpperCase('tr-TR')}
      </h1>
      <p style={{whiteSpace: 'pre-line', lineHeight: '1.5rem'}}>
        {t(
          (localization as Localization)?.[selectedLanguage][
            product?.article as string
          ],
        )}
      </p>

      <Button
        label={t(
          (localization as Localization)?.[selectedLanguage]
            .productCategoryCallToActionButtonLabel as string,
        )}
        aria-label={t(
          (localization as Localization)?.[selectedLanguage]
            .productCategoryCallToActionButtonLabel as string,
        )}
        icon="pi pi-arrow-right"
        className="p-button-primary"
        iconPos="right"
        severity="danger"
        onClick={() => navigate('/' + selectedLanguage + t('pathMenuContact'))}
      />

      <ProductGrid products={product?.products || []} />
    </section>
  );
};

export default memo(ProductCategory);
